<div class="m-3">
  <h2>Biz Dev Dashboard</h2>

  <div class="row">
    <div class="col-md-6">
      @if (showSearchUI) {
        <app-search-template searchLabel="Search" [hideTitle]="false" [showSearchButton]=true [reset]=true [showLocations]=false [showDevelopments]=false
          [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
          [showReservationStatuses]=false [showStartDate]=false [showEndDate]=false [showSaleDateStart]=true
          [showSaleDateEnd]=true [defaultStartDate]="defaultStartDate" [showSaleYear]=false [displayRecordsOnPageLoad]="false"
          [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
          [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
        </app-search-template>
      }
    </div>

    <div class="col-md-6 d-flex justify-content-end">
      <div class="d-flex">
        <div class="m-2">
          <button pButton pRipple (click)="onWeeklyReport()" class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;" >This Week</button>
        </div>
        <div class="m-2">
          <button pButton pRipple (click)="onMonthlyReport()" class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;" >This Month</button>
        </div>
        <div class="m-2">
          <button pButton pRipple (click)="onYearlyReport()" class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;" >This Year</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row g-3 m-0 m-3 pb-3 pt-0 report-statistics">
  <div class="col">
    <div class="statistics bg-1">
      <p>Proformas sent:</p>
      <h1>{{proformas?.length}}</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-2">
      <p>New leads:</p>
      <h1>0</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-3">
      <p>New opportunity:</p>
      <h1>0</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-4">
      <p>Wins:</p>
      <h1>0</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-5">
      <p>losses:</p>
      <h1>0</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-6">
      <p>Quit:</p>
      <h1>0</h1>
    </div>
  </div>
  <div class="col">
    <div class="statistics bg-1">
      <p>Fire:</p>
      <h1>0</h1>
    </div>
  </div>
</div>

<div class="row report-statistics m-3">
  <div class="col-lg-6 p-3">
    <div class="statistics bg-1 px-5">
      <span class="p-float-label w-100 mb-3">
        <div class="row">
          <div class="col-10">
            <h1>Proforma</h1>
          </div>
          <div class="col-2 py-0 d-flex justify-content-end align-items-center">
            <button class="btn btn-icon btn-success rounded-pill" (click)="onOpenFormAddProforma()">
              <i class="pi pi-plus"></i>
            </button>
          </div>
        </div>
        <p-table #pt [value]="proformas" [lazy]="false" dataKey="proformaId"
          selectionMode="single" [(selection)]="proforma"  (onRowSelect)="onRowSelectProforma($event)" [resizableColumns]="true" [autoLayout]="true"
          [responsive]="true">

          <ng-template pTemplate="header">
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field"
                  [ngStyle]="{'width': col.width}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-proforma>
            <tr [pSelectableRow]="proforma">
              <td>{{proforma.sentDate | date}} </td>
              <td>{{removeNullFromString(proforma.senderName)}}</td>
              <td>{{proforma.recipientMail}}</td>
              <td>{{proforma.subjAdrDevelopmentName}}</td>
              <td>{{proforma.subjAdrUnit}}</td>
              <td>{{proforma.subjAdrCity}}</td>
              <td>{{proforma?.openedDate | date}}</td>
            </tr>
          </ng-template>
        </p-table>
      </span>
    </div>
  </div>
  <div class="col-lg-6 p-3">
    <div class="statistics bg-2 px-5">
      <span class="p-float-label w-100 mb-3">

        <div class="row">
          <div class="col-10">
            <h1>Owner Lead Profiles</h1>
          </div>
          <div class="col-2 py-0 d-flex justify-content-end align-items-center">
            <button class="btn btn-icon btn-success rounded-pill" (click)="formAddOwnerLeadProfile()">
              <i class="pi pi-plus"></i>
            </button>
          </div>
        </div>

        <p-table #pt [value]="ownerLeadProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)"
          dataKey="ownerLeadProfileId" selectionMode="single" [(selection)]="ownerLeadProfile"
          (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="true" [rows]="25"
          [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
          currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
          [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta"
          styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
          [autoLayout]="true" [responsive]="true">

          <ng-template pTemplate="header">
            <tr>
              @for (col of columns1; track col) {
                <th [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-ownerLeadProfile>
            <tr [pSelectableRow]="ownerLeadProfile">
              <td>{{ownerLeadProfile.lastName}}</td>
              <td>{{ownerLeadProfile.createDate | date}}</td>
              <td>{{ownerLeadProfile.lastUpdate | date}}</td>
              <td>{{ownerLeadProfile?.assignToSalesAgnt1?.lastName}}</td>
              <td>{{ownerLeadProfile?.assignToSalesAgnt2?.lastName}}</td>
              <td>{{ownerLeadProfile?.assignToSalesAgnt3?.lastName}}</td>
              <td>{{ownerLeadProfile?.assignToSalesAgnt4?.lastName}}</td>
              <td>{{ownerLeadProfile?.assignToMgr?.lastName}}</td>
              <td>{{ownerLeadProfile.subjAdrLocationDesc}}</td>
              <td>{{ownerLeadProfile.listingStatus}}</td>
              <td>{{getRealtorLastName(ownerLeadProfile)}}</td>
            </tr>
          </ng-template>
        </p-table>
      </span>
    </div>
  </div>
  <div class="col-lg-6 p-3">
    <div class="statistics bg-2 px-5">
      <span class="p-float-label w-100 mb-3">

        <div class="row">
          <div class="col-10">
            <h1>Real Estate</h1>
          </div>
        </div>

        <p-table #pt [value]="realEstates" [lazy]="true" (onLazyLoad)="loadLazyForRealEstate($event)" dataKey="realEstateId"
          selectionMode="single" [(selection)]="realEstate" [loading]="loading" [paginator]="showPagination"
          [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
          currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
          [totalRecords]="recordTotal1" sortMode="multiple" [multiSortMeta]="multiSortMeta"
          styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
          [autoLayout]="true" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              @for (col of columns2; track col) {
                <th [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              }
              <th>Action</th>
              <th [ngStyle]="{'width': 'auto'}"></th>
            </tr>
            <!-- <tr *ngIf="showFilter">
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mlsAllId', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mlsNumber', 'in')">
            </th>

            <th [ngStyle]="{'width': 'auto'}"></th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
            (input)="pt.filter($event.target.value, 'kbmPropertyType', 'in')"></th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'createDate', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastUpdate', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
            (input)="pt.filter($event.target.value, 'listingPrice', 'in')"></th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'statusDesc', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressZip', 'in')">
            </th>
            <th [ngStyle]="{'width': 'auto'}"></th>
          </tr> -->
        </ng-template>
        <ng-template pTemplate="body" let-realEstate>
          <tr [pSelectableRow]="realEstate">
            <td><img width="80px" height="auto" [src]="getImageURL(realEstate)"></td>
            <td>{{realEstate.statusDesc}}</td>
            <td>{{realEstate.listingDate}} </td>
            <td>{{formatCurrency(realEstate.listingPrice)}} </td>
            <td>{{realEstate.kbmPropertyType}} </td>
            <td>{{realEstate.addressStreetNumber}} {{realEstate.addressStreetName}} {{realEstate.addressUnit}} {{realEstate.addressCity}} {{realEstate.addressState}} </td>
            <td>{{realEstate?.listingAgentName}}</td>
            <td>{{realEstate?.listingAgentEmail}}</td>
            <td>{{realEstate?.listingAgentPhone}}</td>
            <td>
              <span style="float:none">
                <p-dropdown class="w-100" [options]="propertyOptions" optionLabel="name"
                (onChange)="onActionSelection($event, realEstate)" optionValue="value" appendTo="body" placeholder="Select option" ></p-dropdown>
              </span>
            </td>
            <td><span style="float:none">

            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </span>
</div>
</div>
<div class="col-lg-6 p-3">
  <div class="statistics bg-2 px-5">
    <span class="p-float-label w-100 mb-3">

      <div class="row">
        <div class="col-10">
          <h1>Tasks</h1>
        </div>
      </div>
      <app-task-home [isFolderNav]="false"></app-task-home>
    </span>
  </div>
</div>
</div>